export const statsBarData = [
  { name: "Order Received", percentage: 95 },
  { name: "Customs Processing", percentage: 85 },
  { name: "Customs Clearance", percentage: 75 }
]